/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * eCFR SDK
 * TypeScript SDK and Model Context Protocol server for the Electronic Code of Federal Regulations (eCFR) API
 * OpenAPI spec version: 1.0.0
 */
import {
  GetApiAdminV1CorrectionsJsonParams,
  GetApiSearchV1ResultsParams,
  GetApiSearchV1CountParams,
  GetApiSearchV1SummaryParams,
  GetApiSearchV1CountsDailyParams,
  GetApiSearchV1CountsTitlesParams,
  GetApiSearchV1CountsHierarchyParams,
  GetApiSearchV1SuggestionsParams,
  GetApiVersionerV1AncestryDateTitleTitleJsonParams,
  GetApiVersionerV1FullDateTitleTitleXmlParams,
  GetApiVersionerV1VersionsTitleTitleJsonParams
} from './http-schemas';

import {
  getApiAdminV1AgenciesJson,
  getApiAdminV1CorrectionsJson,
  getApiAdminV1CorrectionsTitleTitleJson,
  getApiSearchV1Results,
  getApiSearchV1Count,
  getApiSearchV1Summary,
  getApiSearchV1CountsDaily,
  getApiSearchV1CountsTitles,
  getApiSearchV1CountsHierarchy,
  getApiSearchV1Suggestions,
  getApiVersionerV1AncestryDateTitleTitleJson,
  getApiVersionerV1FullDateTitleTitleXml,
  getApiVersionerV1StructureDateTitleTitleJson,
  getApiVersionerV1TitlesJson,
  getApiVersionerV1VersionsTitleTitleJson
} from './http-client';
  
/**
 * All top-level agencies in name order with children also in name order
 * @summary Agencies
 */

export const getApiAdminV1AgenciesJsonHandler = async () => {
  const res = await getApiAdminV1AgenciesJson();

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The Corrections service can be used to determine all corrections or can be filtered by title, effective date, or correction date.

 * @summary Corrections route returns all eCFR corrections.
 */

export type getApiAdminV1CorrectionsJsonArgs = {
  queryParams: GetApiAdminV1CorrectionsJsonParams;
}

export const getApiAdminV1CorrectionsJsonHandler = async (args: getApiAdminV1CorrectionsJsonArgs) => {
  const res = await getApiAdminV1CorrectionsJson(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The Corrections service can be used to determine all corrections for the given title.
 * @summary Corrections title route returns all corrections for the supplied title.
 */

export type getApiAdminV1CorrectionsTitleTitleJsonArgs = {
  pathParams: {
    title: string
  };
}

export const getApiAdminV1CorrectionsTitleTitleJsonHandler = async (args: getApiAdminV1CorrectionsTitleTitleJsonArgs) => {
  const res = await getApiAdminV1CorrectionsTitleTitleJson(args.pathParams.title);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search results
 */

export type getApiSearchV1ResultsArgs = {
  queryParams: GetApiSearchV1ResultsParams;
}

export const getApiSearchV1ResultsHandler = async (args: getApiSearchV1ResultsArgs) => {
  const res = await getApiSearchV1Results(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search result count
 */

export type getApiSearchV1CountArgs = {
  queryParams: GetApiSearchV1CountParams;
}

export const getApiSearchV1CountHandler = async (args: getApiSearchV1CountArgs) => {
  const res = await getApiSearchV1Count(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search summary details
 */

export type getApiSearchV1SummaryArgs = {
  queryParams: GetApiSearchV1SummaryParams;
}

export const getApiSearchV1SummaryHandler = async (args: getApiSearchV1SummaryArgs) => {
  const res = await getApiSearchV1Summary(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search result counts by date
 */

export type getApiSearchV1CountsDailyArgs = {
  queryParams: GetApiSearchV1CountsDailyParams;
}

export const getApiSearchV1CountsDailyHandler = async (args: getApiSearchV1CountsDailyArgs) => {
  const res = await getApiSearchV1CountsDaily(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search result counts by title
 */

export type getApiSearchV1CountsTitlesArgs = {
  queryParams: GetApiSearchV1CountsTitlesParams;
}

export const getApiSearchV1CountsTitlesHandler = async (args: getApiSearchV1CountsTitlesArgs) => {
  const res = await getApiSearchV1CountsTitles(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search result counts by hierarchy
 */

export type getApiSearchV1CountsHierarchyArgs = {
  queryParams: GetApiSearchV1CountsHierarchyParams;
}

export const getApiSearchV1CountsHierarchyHandler = async (args: getApiSearchV1CountsHierarchyArgs) => {
  const res = await getApiSearchV1CountsHierarchy(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * @summary Search suggestions
 */

export type getApiSearchV1SuggestionsArgs = {
  queryParams: GetApiSearchV1SuggestionsParams;
}

export const getApiSearchV1SuggestionsHandler = async (args: getApiSearchV1SuggestionsArgs) => {
  const res = await getApiSearchV1Suggestions(args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The Ancestry service can be used to determine the complete ancestry to a leaf node at a specific point in time.
### Example
The complete hierarchy for **2 CFR 1532.137** is
```
Title 2
  Subtitle B
    Chapter XV
      Part 1532
        Subpart A
          Section 1532.137
```
To retrieve this complete hierarchy you can use the ancestry endpoint and provide a Title, Part and Section (you can provide additional layers of the hierarchy) to retrieve a full ancestry.
See sample json responses below.

 * @summary Ancestors route returns all ancestors (including self) from a given level through the top title node.
 */

export type getApiVersionerV1AncestryDateTitleTitleJsonArgs = {
  pathParams: {
    date: string,
    title: string
  };
  queryParams: GetApiVersionerV1AncestryDateTitleTitleJsonParams;
}

export const getApiVersionerV1AncestryDateTitleTitleJsonHandler = async (args: getApiVersionerV1AncestryDateTitleTitleJsonArgs) => {
  const res = await getApiVersionerV1AncestryDateTitleTitleJson(args.pathParams.date, args.pathParams.title, args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The title source route can be used to retrieve the source xml for a complete title or subset. The subset of xml is determined by the lowest leaf node given. For example, if you request Title 1, Chapter I, Part 1, you'll receive the XML only for Part 1 and its children.
If you request a section you'll receive the section XML inside its parent Part as well as relevant non-section sibling nodes (Auth, Source, etc).
The largest title source xml files can be dozens of megabytes.

[GPO eCFR XML User guide](https://github.com/usgpo/bulk-data/blob/master/ECFR-XML-User-Guide.md)

 * @summary Source XML for a title or subset of a title. Requests can be for entire titles or part level and below.  Downloadable XML document is returned for title requests.  Processed XML is returned if part, subpart, section, or appendix is requested.
 */

export type getApiVersionerV1FullDateTitleTitleXmlArgs = {
  pathParams: {
    date: string,
    title: string
  };
  queryParams: GetApiVersionerV1FullDateTitleTitleXmlParams;
}

export const getApiVersionerV1FullDateTitleTitleXmlHandler = async (args: getApiVersionerV1FullDateTitleTitleXmlArgs) => {
  const res = await getApiVersionerV1FullDateTitleTitleXml(args.pathParams.date, args.pathParams.title, args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The structure JSON endpoint returns the complete structure of a title back as json. This format does not include the content of the title but does include all structure and content nodes as well as their meta data including their type, label, description, identifier and children.
 * @summary Structure JSON for a title
 */

export type getApiVersionerV1StructureDateTitleTitleJsonArgs = {
  pathParams: {
    date: string,
    title: string
  };
}

export const getApiVersionerV1StructureDateTitleTitleJsonHandler = async (args: getApiVersionerV1StructureDateTitleTitleJsonArgs) => {
  const res = await getApiVersionerV1StructureDateTitleTitleJson(args.pathParams.date, args.pathParams.title);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * The Title service can be used to determine the status of each individual title and of the overall status of title imports and reprocessings. It returns an array of all titles containing a hash for each with the name of the title, the latest amended date, latest issue date, up-to-date date, reserved status, and if applicable, processing in progress status. The meta data returned indicates the latest issue date and whether titles are currently being reprocessed.
 * @summary Summary information about each title
 */

export const getApiVersionerV1TitlesJsonHandler = async () => {
  const res = await getApiVersionerV1TitlesJson();

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};

/**
 * Returns the content versions meeting the specified criteria. Each content object includes its identifier, parent hierarchy, last amendment date and issue date it was last updated. Queries return content versions `on` an issue date, or before or on a specific issue date `lte` or on or after `gte` a specific issue date. The `gte` and `lte` parameters may be combined. Use of the `on` parameter precludes use of `gte` or `lte`. In the response, the `date` field is identical to `amendment_date` and is deprecated.
<br>
A response of `400 Bad Request` indicates that your request could not be processed. If possible the response will include a message indicating the problem.
<br>
A response of `503 Service Unavailable` indicates that the title is currently unavailable, typlically because it is currently being processed. The value of the `Retry-After` header suggests a number of seconds to wait before retrying the request.

 * @summary Returns an array of all sections and appendices inside a title.
 */

export type getApiVersionerV1VersionsTitleTitleJsonArgs = {
  pathParams: {
    title: string
  };
  queryParams: GetApiVersionerV1VersionsTitleTitleJsonParams;
}

export const getApiVersionerV1VersionsTitleTitleJsonHandler = async (args: getApiVersionerV1VersionsTitleTitleJsonArgs) => {
  const res = await getApiVersionerV1VersionsTitleTitleJson(args.pathParams.title, args.queryParams);

  return {
    content: [
      {
        type: 'text' as const,
        text: JSON.stringify(res),
      },
    ],
  };
};
